import { FrontDate } from "../../../domain/model/frontDate";
import { SearchHighlight } from "../../../domain/model/search_highlight";
import { occupationsByDeprecated } from "../../../util/depricated";
import { entity } from "../rpc/api";
import ProjectList = entity.ProjectList;

import SearchHighlightAtServer = entity.SearchHighlight;

class ProjectConvertResponse {
  public static from(from: entity.Project): ProjectConvertResponse {
    // Backend => FrontEnd における型変換
    const operatingDateDate: FrontDate = FrontDate.from(from.operatingDate);
    const createdAtDate: FrontDate = FrontDate.from(from.createdAt);

    const highlights: SearchHighlight[] = from.highlights.map(
      (highlight: SearchHighlightAtServer) => {
        return SearchHighlight.from(highlight);
      }
    );

    return new ProjectConvertResponse(
      from.id,
      from.companyID,
      from.name,
      from.description,
      from.background,
      from.preferentialExperience,
      from.gsThumbnailURL,
      from.signedThumbnailURL,
      from.place,
      from.workingHourRange,
      from.paymentRange,
      from.workingDuration,
      occupationsByDeprecated(from.occupations),
      from.status,
      operatingDateDate,
      from.isHideCompany,
      createdAtDate,
      highlights,
      from.shouldShowByContract,
      from.shouldShowByScout,
      from.messageRoomNum as number
    );
  }

  constructor(
    // 案件ID
    public readonly id: string,
    // 企業ID
    public readonly companyID: string,
    // 案件タイトル
    public readonly name: string,
    // 業務内容
    public readonly description: string,
    // 募集背景
    public readonly background: string,
    // 求める経験
    public readonly preferentialExperience: string,
    // 案件TOP画像
    public readonly gsThumbnailURL: string,
    public readonly signedThumbnailURL: string,
    // 可動場所
    public readonly place: entity.Project.Place,
    // 可動時間
    public readonly workingHourRange: entity.Project.WorkingHourRange,
    // 報酬目安
    public readonly paymentRange: entity.Project.PaymentRange,
    // 稼働期間
    public readonly workingDuration: entity.Project.WorkingDuration,
    // 職種区分
    public readonly occupations: entity.Project.Occupation[],
    // 案件ステータス
    public readonly status: entity.Project.Status,
    // 稼働希望年月日
    public readonly operatingDate: FrontDate,
    // company 非表示フラグ
    public readonly isHideCompany: boolean,
    // (タイムスタンプ)
    public readonly createdAt: FrontDate,

    public readonly highlights: SearchHighlight[],

    public readonly shouldShowByContract: boolean,
    public readonly shouldShowByScout: boolean,
    public readonly messageRoomNum: number
  ) {}
}

class ProjectConvertResponseList {
  public static from(from: ProjectList): ProjectConvertResponseList {
    const items: ProjectConvertResponse[] = [];

    from.items.map((item, index) => {
      return items.push(ProjectConvertResponse.from(item as entity.Project));
    });

    return new ProjectConvertResponseList(items);
  }

  constructor(public readonly items: ProjectConvertResponse[]) {}
}

export { ProjectConvertResponse, ProjectConvertResponseList };



// WEBPACK FOOTER //
// ./src/infra/api/service/project_api_convert.ts